import { useState, useEffect } from 'react'

import './online.css'

const Online = ({data}) => {

      const [online, setOnline] = useState([])
      const id_xat = data.id_xat

      async function getOnline(id){
            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id}`)
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Error: ', err)
            }
      }

      useEffect(() => {
            getOnline(id_xat)
      }, [id_xat])

      return (
            <div className="wrapper_online">
                  <div className="online_avatar">
                        <img src={data.avatar} alt={data.name} />
                        <div className={(online.status === 'online') ? "online_dots green" : "online_dots red"}></div>
                  </div>
                  <span>{(online.status === 'online') ? "Online Now" : "Offline"}</span>
            </div>
      )
}

export default Online
